module.exports = __webpack_public_path__ + "c_static/img/invite-friends_img_Leaderboard-bg_default@2x.8cde215.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/邀请好友/invite-friends_img_Leaderboard-bg_default@2x.png
// module id = RaiS
// module chunks = 33